import * as actions from "./actions";
import { Map } from "immutable";
import { Record } from "../transit";
import { ValidationError } from "../lib/validation";
import Alert from "react-s-alert";

import { hashFromObj } from "../lib/utils/hash";

import { normalize, Schema, arrayOf } from "normalizr";

const offer = new Schema("offers", { idAttribute: "uid" });

const State = Record(
  {
    map: Map(),
    results: Map(),
    meta: new (Record(
      {
        currentPage: 1,
        limit: 15,
        offset: 0,
        sortDir: "desc",
        sortField: "createdAt"
      },
      "meta"
    ))(),
    deleteStatus: 0,
    form: new (Record(
      {
        loading: false,
        error: null
      },
      "form"
    ))()
  },
  "offer"
);

const offersReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.CREATE_OFFER: {
      return state.setIn(["form", "loading"], true);
    }

    case actions.CREATE_OFFER_SUCCESS: {
      Alert.success("Dodano ofertę", {
        position: "bottom-right",
        timeout: 3000
      });
      return state.setIn(["form", "loading"], false);
    }

    case actions.CREATE_OFFER_ERROR: {
      const { errors, data } = action.payload;
      return state
        .setIn(["form", "error"], errors)
        .setIn(["form", "loading"], false);
    }

    case actions.CREATE_OFFER_FINALLY: {
      return state.setIn(["form", "loading"], false);
    }

    case actions.UPDATE_OFFER: {
      return state.setIn(["form", "loading"], true);
    }

    case actions.UPDATE_OFFER_SUCCESS: {
      const { data } = action.payload;
      return state.setIn(["form", "loading"], false);
    }

    case actions.UPDATE_OFFER_ERROR: {
      const { errors, data } = action.payload;
      return state
        .setIn(["form", "error"], errors)
        .setIn(["form", "loading"], false);
    }

    case actions.UPDATE_OFFER_FINALLY: {
      return state.setIn(["form", "loading"], false);
    }

    case actions.GET_OFFERS_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, { offers: arrayOf(offer) });
      return state
        .update("map", map => map.merge(nrs.entities.offers))
        .update("results", rs => rs.set(hashFromObj(data), nrs.result));
    }

    case actions.GET_OFFER_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, offer);
      return state.update("map", map => map.merge(nrs.entities.offers));
    }

    case actions.DELETE_OFFER: {
      return state.setIn(["deleteStatus"], 1);
    }

    case actions.DELETE_OFFER_SUCCESS: {
      return state.setIn(["deleteStatus"], 2);
    }

    case actions.DELETE_OFFER_ERROR: {
      return state.setIn(["deleteStatus"], 3);
    }

    case actions.SET_DELETE_STATUS: {
      const { status } = action.payload;
      return state.setIn(["deleteStatus"], status);
    }

    case actions.SET_OFFER_PAGE: {
      const { page } = action.payload;
      const limit = state.getIn(["meta", "limit"]);
      return state
        .setIn(["meta", "currentPage"], page)
        .setIn(["meta", "offset"], (page - 1) * limit);
    }

    case actions.SET_OFFER_SORT: {
      const { field, dir } = action.payload;
      return state
        .setIn(["meta", "sortDir"], dir)
        .setIn(["meta", "sortField"], field);
    }

    case actions.OFFER_CLEAR_ERROR: {
      const { field } = action.payload;

      let errors =
        state.form.error && state.form.error && state.form.error.errors;
      if (errors && errors[field]) {
        errors[field] = undefined;
      }

      return state.setIn(["form", "error"], new ValidationError(errors));
    }

    case actions.OFFER_CLEAR_FORM: {
      return state.setIn(["form", "error"], null);
    }

    default:
      return state;
  }
};

export default offersReducer;



// WEBPACK FOOTER //
// ./src/common/offer/reducer.js